import { useMemo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { FiArrowDown, FiMail } from "react-icons/fi";
import headerImg from "../assets/img/karan-astronaut.webp";
import { GlassLayers } from "./LiquidGlass";
import { WebGLShader } from "./WebGLShader";

const proof = [
  { value: "17", label: "live games" },
  { value: "6", label: "languages" },
  { value: "ConveGenius", label: "App & Game Dev" },
  { value: "IIT Madras", label: "B.Sc. Data Science" },
];

export const Banner = () => {
  const stars = useMemo(
    () =>
      Array.from({ length: 80 }, (_, i) => ({
        id: i,
        size: 0.8 + Math.random() * 2.8,
        x: Math.random() * 100,
        y: Math.random() * 100,
        delay: Math.random() * 6,
        duration: 3 + Math.random() * 9,
        opacity: 0.4 + Math.random() * 0.6,
      })),
    []
  );

  return (
    <section className="banner hero-neo" id="home">
      {/* Single canvas renders both top and bottom waves */}
      <WebGLShader />

      <div className="starfield" aria-hidden="true" style={{ zIndex: 1 }}>
        {stars.map((star) => (
          <span
            key={star.id}
            className="star"
            style={{
              width: `${star.size}px`,
              height: `${star.size}px`,
              left: `${star.x}%`,
              top: `${star.y}%`,
              animationDelay: `${star.delay}s`,
              animationDuration: `${star.duration}s`,
              opacity: star.opacity,
            }}
          />
        ))}
      </div>

      <Container style={{ position: "relative", zIndex: 4 }}>
        <Row className="align-items-center g-5">
          <Col xs={12} lg={6}>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <p className="hero-kicker">Welcome to my universe…</p>
              <h1>
                Hi, I&apos;m Karan
                <span className="visually-hidden"> — </span>
                <span className="hero-role">App & Game Developer</span>
              </h1>

              <p>
                I build browser games and interactive lessons at ConveGenius — 17 live titles, from physics racers to trig shooters.
              </p>

              <div className="hero-actions">
                <a
                  href="#projects"
                  className="hero-cta star-hover"
                  style={{
                    position: "relative",
                    background: "linear-gradient(90deg, #57ecff, #4f8dff)",
                    border: "1px solid rgba(104, 225, 255, 0.6)",
                    boxShadow: "0 8px 28px rgba(84, 151, 255, 0.5)",
                    color: "#020b1a",
                    fontWeight: 700,
                  }}
                >
                  <GlassLayers tint="rgba(87, 236, 255, 0.1)" />
                  <span className="hero-btn-label">
                    View My Work <FiArrowDown aria-hidden="true" />
                  </span>
                </a>

                <a
                  href="mailto:karankumarofficial66@gmail.com?subject=Hi%20Karan%20%E2%80%94%20from%20your%20portfolio"
                  className="ghost-btn hero-cta-secondary star-hover"
                >
                  <GlassLayers />
                  <span className="hero-btn-label">
                    <FiMail aria-hidden="true" /> Get in touch
                  </span>
                </a>
              </div>

              <ul className="hero-proof" aria-label="At a glance">
                {proof.map((item) => (
                  <li key={item.label}>
                    <strong>{item.value}</strong>
                    <span>{item.label}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          </Col>

          <Col xs={12} lg={6}>
            <motion.div
              className="hero-visual parallax medium"
              initial={{ opacity: 0, scale: 0.92, y: 24 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              transition={{ duration: 0.85, delay: 0.12, ease: "easeOut" }}
            >
              <img src={headerImg} alt="Illustration of Karan as an astronaut floating in space" loading="eager" fetchpriority="high" width="1117" height="935" />
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
